namespace app.tarefas.minhasTarefas {
    
    import IDirective = angular.IDirective;
    import IDirectiveFactory = angular.IDirectiveFactory;
    import IScope = angular.IScope;
    import IAngularEvent = angular.IAngularEvent;
    import IDocumentService = angular.IDocumentService;
    import IDialogService = angular.material.IDialogService;
    import INotification = app.notification.INotification;

    interface NotasScope extends IScope {
        tarefa: ITask;
    }
    
    class NotasController {
        
        public tarefa: ITask;
        
        /** @ngInject */
        public constructor($scope: NotasScope, private $mdDialog: IDialogService, private $document: IDocumentService) {
            this.tarefa = $scope.tarefa;
            
            $scope.$on("task:annotated", (event: IAngularEvent, notification: INotification) => {
                let tarefa: ITask = notification.content;
                
                if (tarefa.id === this.tarefa.id && tarefa.context === this.tarefa.context) {
                    this.tarefa.notes = tarefa.notes;
                }
            });
        }
        
        public setNotas(): void {
            this.$mdDialog.show({
                controller         : AnnotateController,
                controllerAs       : "vm",
                templateUrl        : "app/main/tarefas/minhas-tarefas/dialogs/notes/notes.html",
                parent             : this.$document.find('body'),
                clickOutsideToClose: true,
                locals             : { task : this.tarefa }
            });
        }
    }
    
    class NotasDirective implements IDirective {

        public restrict = "AE";
        public templateUrl = "app/main/tarefas/minhas-tarefas/directives/notas.tpl.html";
        public controllerAs = "vm";
        public controller = NotasController;
            
        public scope: Object = {
            tarefa: "="
        };

        constructor() {	}
        
        public static factory(): IDirectiveFactory {
            return () => new NotasDirective();
        }
    
    }
    
    angular.module("app.tarefas.minhas-tarefas").directive("notasTarefa", NotasDirective.factory());
}